/* Add to bag: POST /cart/add.js, refresh the header count, then open the bag. Enhances every form[data-add-form]. */
(function () {
  window.F2F = window.F2F || {};
  var MAX_PAIRS = 3;
  var EVALUATION_HANDLE = 'motionform3d-evaluation';

  function root() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
  }

  function say(el, message, withLink) {
    if (!el) return;
    el.textContent = message;
    if (withLink) {
      var a = document.createElement('a');
      a.href = root() + 'cart';
      a.textContent = ' View bag →';
      el.appendChild(a);
    }
  }

  /* opts: { id, handle, properties, status } */
  window.F2F.addToBag = function (opts) {
    say(opts.status, '');
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var pairs = cart.items.reduce(function (sum, item) {
          return item.handle === EVALUATION_HANDLE ? sum : sum + item.quantity;
        }, 0);
        if (opts.handle !== EVALUATION_HANDLE && pairs >= MAX_PAIRS) {
          say(opts.status, 'Your bag holds up to three pairs. Review your bag to change a pair.', true);
          return false;
        }
        return fetch(root() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(opts.id), quantity: 1, properties: opts.properties || {} }].concat(
            opts.evaluationId && !cart.items.some(function (item) { return item.handle === EVALUATION_HANDLE; })
              ? [{ id: Number(opts.evaluationId), quantity: 1 }] : []) })
        }).then(function (r) {
          return r.json().then(function (body) {
            if (!r.ok) {
              say(opts.status, body.description || body.message || 'This item could not be added. Please try again.');
              return false;
            }
            var done = function () { window.location.assign(root() + 'cart'); };
            return (window.F2F.refreshCartCount ? window.F2F.refreshCartCount() : Promise.resolve()).then(done, done).then(function () { return true; });
          });
        });
      })
      .catch(function () {
        say(opts.status, 'This item could not be added. Please try again.');
        return false;
      });
  };

  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('form[data-add-form]') : null;
    if (!form) return;
    e.preventDefault();
    var properties = {};
    new FormData(form).forEach(function (value, name) {
      if (name.indexOf('properties[') === 0 && name.slice(-1) === ']' && typeof value === 'string' && value) properties[name.slice(11, -1)] = value;
    });
    var button = form.querySelector('[type="submit"]');
    if (button) button.disabled = true;
    window.F2F.addToBag({
      id: form.elements.id.value,
      handle: form.getAttribute('data-handle'),
      properties: properties,
      evaluationId: (form.querySelector('[data-evaluation-id]:checked') || {}).value ? form.querySelector('[data-evaluation-id]:checked').getAttribute('data-evaluation-id') : '',
      status: form.querySelector('[data-add-status]')
    }).then(function (ok) { if (button && !ok) button.disabled = false; });
  });
})();
